<template>
    <div class="element-wrapper" @click="showMenu">        
        <ul class="choice-container" v-show="is_show">
            <li class="choice-element" :class="{'active': selectIndex === ind}" v-for="(item, ind) in choices" :key="ind" @click="selected($event,ind)" v-text="item.problemDesc"></li>
        </ul>
        <div class="element-content-default" v-show='selectIndex == -1'>
            <span v-text="label"></span>
            <i class="icon icon-arrow-down" :class="{'icon-arrow-up':is_show}"></i>
        </div>
        <div class="element-content" v-show='selectIndex > -1'>
            <span v-text="selectIndex == -1 ?'':choices[selectIndex].problemDesc"></span>
            <i class="icon icon-arrow-down" :class="{'icon-arrow-up':is_show}"></i>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
// import { useStore } from 'vuex'
export default {
    props:{
        title:{
            type:String
        },
        label:{
            type:String,
            default:'Please Select'
        },
        choices:{
            type:Object
        },
        selectIndex:{
            type:Number
        },
        keys:{
            type:String
        },
        is_show:{
            type:Boolean
        },
        is_error:{
            type:Boolean
        },
        component_id:{
            type:Number
        },        
    },
    setup (props, { emit }) {        
        const show_error = ref(false)
        const selected = (e, ind) => {
            e.stopPropagation();                        
            emit("setValue",ind,props.keys)   
            console.log(ind)
            try {
                emit('modify',                     
                    false                    
                )    
            } catch (error) {
                console.log(error)
            }                     
        }
        const showMenu = (e) => {
            e.stopPropagation();
            if(props.is_show)return 
            try {
                emit('modify',                     
                    true                    
                )     
            } catch (error) {
                console.log(error)
            } 
        }        
        const showError = () => {
            if(props.required & !props.selectIndex){
                show_error.value = true
            }
        } 
        return {            
            selected,
            showMenu,            
            show_error,
            showError,            
        }
    }
}
</script>
<style lang="less" scoped>
@import "assets/less/icon.less";
.element-wrapper{
    padding-bottom: 30px;
    border-bottom: 2px solid #EFEEF1;
    position: relative;
    margin-bottom: 30px;
    &.is_error{
        border-bottom:  2px solid #C5340B;       
    }
    .element-title{
        
        color:#73698F;
        font-size: 26px;  
        overflow: hidden;
        padding:15px 0;      
        h3{
            float:left;
        }
        .icon-exclaim{
            float:left;
            margin-left: 20px;
        }
        .icon-arrow-down{
            float:right
        }
    }
    .element-content-default{
        margin-top: 30px;
        color:#D0CDDA;
        font-size: 36px;
        height:40px;
        line-height: 40px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        span{
            flex:1;
        }        
    }
    .element-content{
        margin-top: 30px;
        color:#000;
        font-size: 36px;
        height:40px;
        line-height: 40px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        span{
            flex:1;
        }        
    }
    .choice-container{  
        // display: none;      
        position: absolute;
        width: 575px;
        padding:0 30px;      
        background:#fff; 
        z-index:99; 
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        top:50px;
        .choice-element{            
            border-bottom: 2px solid #EFEEF1;
            padding:40px;            
            color:#000;
            font-size: 32px;
            &.active{
                color:#00CD98;
            }
        }
    }
}
    
</style>